import React from "react";

export interface UnorderedListProps {
  children: React.ReactNode;
}

export const UnorderedList = ({ children }: UnorderedListProps) => {
  return <ul className="mb-4 space-y-2 text-left text-gray-500 sm:mb-5 dark:text-gray-400">{children}</ul>;
};
